module.exports = __webpack_public_path__ + "img/product5.854cfe03.png";